'use strict';

var scrollAnimate = require('../components/scrollAnimate');

var dataLayer = window.dataLayer || [];

let gtmSearchDataInput = $('#gtmSearchData');
if (gtmSearchDataInput && gtmSearchDataInput.val()) {
    dataLayer.push(JSON.parse(gtmSearchDataInput.val()));
}
window.isfilterApplied = false;
window.isUserClikedOnShow = false;
window.previousSearchUrl = null;

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
    $('body').trigger('search:updateDom', selector);
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement .collapse.show').each(function () {
        var content = $(this);
        var refinementId = $(this).attr('id'); // Get the open refinement's ID
        var newRefinement = $results.find('#' + refinementId); // Find the corresponding refinement in the new results
        if (newRefinement.length) {
            newRefinement.addClass('show'); // Keep it open in updated results
        }
        if (content.find('.refinement-list').hasClass('filter-expanded')) {
            $results.find('#' + refinementId).children('.refinement-list')
                .addClass('filter-expanded')
                .children('.filter-option')
                .removeClass('d-none');
        } else {
            $results.find('#' + refinementId).children('.refinement-list')
                .removeClass('filter-expanded')
                .children('.filter-option')
                .addClass('d-none');
        }
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.results-count-continer',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.results-count-modal',
        '.header-banner-plp',
        '.plp-refinement-section',
        '.no-fliter-results',
        '.filter-bar',
        '.sort-n-filter',
        '.sort-options',
        '.top-categories',
        '.tiles-total-count'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * sets observer to trigger load more even on the given element
 * @param {Object} element jquery element to set intesection observer on
 */
function setLoadMoreObserver(element) {
    var loadMoreBtn = $('.show-more');
    const loadmoreObserver = new IntersectionObserver(function (entries) {
        var elementEntry = entries[0];
        if (elementEntry.isIntersecting) {
            if (loadMoreBtn.length > 0) {
                $('.show-more button').trigger('click');
            }
            loadmoreObserver.unobserve(elementEntry.target);
        }
    });

    if (element.length) {
        loadmoreObserver.observe(element[0]);
    }
}

/**
 * initialize auto scroll observer
 */
function initAutoScroll() {
    const lastProductCart = $('.row.product-grid .product-tile:last');
    var loadMoreBtn = $('.show-more');
    setLoadMoreObserver(lastProductCart, loadMoreBtn);
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Handles the application and removal of search filters on the product grid.
 *
 * Initiates an Ajax request to update the product grid based on the selected filters.
 * Updates the browser history with the new search URL for SEO purposes.
 * Manages the UI state of filter buttons and modals.
 *
 * @param {jQuery} $ele - The jQuery element that triggered the filter action.
 * @param {Event} e - The event object associated with the filter action.
 * Triggers various events to update the UI and reinitialize components after filtering.
 */
function handleFilters($ele, e) {
    var $this = $ele;
    $.spinner().start();
    $this.trigger('search:filter', e);

    var searchUrl = $this.data('href') || window.previousSearchUrl;
    var seoUrl = $this.data('seo-href') || searchUrl;
    if (seoUrl) {
        window.history.pushState({}, null, seoUrl);
    }
    var isDeselected = !!($this.is(':checked'));
    var isResetClick = $this.hasClass('resetFilters');
    $.ajax({
        url: searchUrl,
        data: {
            page: $('.grid-footer').data('page-number'),
            selectedUrl: searchUrl
        },
        method: 'GET',
        success: function (response) {
            parseResults(response);
            window.isfilterApplied = !((isResetClick || isDeselected));
            var noFiltersApplied = $('.product-tile').length === 0 && $('.sortnfilter-modal').hasClass('show');
            if (isResetClick || noFiltersApplied) {
                $('.sortnfilter-modal').modal('hide');
            }
            $.spinner().stop();
            initAutoScroll();
            $('body').trigger('init:wislist');
            $('body').trigger('initMarqueeContent');
            $('body').trigger('initializeEinsteinCarouselsPLP');
            scrollAnimate();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

module.exports = {
    sort: function () {
        // Handle sort order menu selection
        $(document).on('click', '.sort-options a', function (e) {
            e.preventDefault();
            var selectedUrl = $(this).attr('href');
            $.spinner().start();
            $(this).closest('.sort-options').find('.active').removeClass('active'); // Remove previous active class
            $(this).parent().addClass('active'); // Add active class to clicked element
            $.ajax({
                url: selectedUrl,
                data: { selectedUrl: selectedUrl },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    $('body').trigger('search:updateDom', '.product-grid');
                    initAutoScroll();
                    $('body').trigger('init:wislist');
                    $('body').trigger('initMarqueeContent');
                    $('body').trigger('initializeEinsteinCarouselsPLP');
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    $('body').trigger('search:updateDom', '.grid-footer');
                    updateSortOptions(response);
                    initAutoScroll();
                    $('body').trigger('init:wislist');
                    $('body').trigger('initMarqueeContent');
                    $('body').trigger('initializeEinsteinCarouselsPLP');
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $(document).on(
            'click',
            '.refinements li button, button.resetFilters, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();
                handleFilters($(this), e);
            }
        );

        // Handle refinement value removal
        $(document).on('click', '.results-count-modal', function () {
            if (window.isfilterApplied && $('.applied-filters-left') && $('.applied-filters-left').data('filtercount') > 0) {
                $('body').trigger('successToast', $(this).data('message'));
                window.isfilterApplied = false;
                window.isUserClikedOnShow = true;
            }
            $('.sortnfilter-modal').modal('hide');
        });
    },

    refinementsOptionsToggle: function () {
        $(document).on('click', '.filter-toggle span', function () {
            var $filterOption = $(this).closest('ul');
            $filterOption.find('.filter-option').toggleClass('d-none');
            $filterOption.toggleClass('filter-expanded');
        });
    },

    closeRefinements: function () {
        $('.container').on('hide.bs.modal', '.sortnfilter-modal', function (e) {
            if (window.isfilterApplied && !window.isUserClikedOnShow && $(window).width() < 1024) {
                $('.filter-confirm-modal').show();
                e.preventDefault();
                e.stopPropagation();
            } else {
                if ($(window).width() > 1024 && window.isfilterApplied && $('.applied-filters-left') && $('.applied-filters-left').data('filtercount') > 0) $('body').trigger('successToast', $('.results-count-modal').data('message'));
                $('.filter-option').addClass('d-none');
                $('ul.refinement-list').removeClass('filter-expanded');
                $('.filter-confirm-modal').hide();
                window.isfilterApplied = false;
                window.isUserClikedOnShow = false;
            }
        });

        $('.container').on('hidden.bs.modal', '.sortnfilter-modal', function () {
            $('.filter-option').addClass('d-none');
            $('ul.refinement-list').removeClass('filter-expanded');
        });

        $(document).on('hidden.bs.collapse', '.refinement .content', function () {
            $(this).parent('.refinement').find('.refinement-list').removeClass('filter-expanded');
            $(this).parent('.refinement').find('.refinement-list .filter-option').addClass('d-none');
        });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },

    onPopState: function () {
        $(window).on('popstate', function () {
            window.location = window.location.href;
        });
    },

    initAutoScroll: initAutoScroll(),

    handleContextualFilters: function () {
        $(document).on('click', 'button.filter-results', function () {
            window.isfilterApplied = false;
            window.previousSearchUrl = window.location.href;
            $('.sortnfilter-modal').modal('show');
        });

        $(document).on('click', '.contextual-filter', function (e) {
            e.preventDefault();
            var selectedID = $(this).attr('data-filter-value');
            var $refinementBtn = $('.refinements li button[data-filter-value="' + selectedID + '"]');
            $refinementBtn.trigger('click');
        });
    },

    handleDiscordFilters: function () {
        $('.filter-confirm-modal, .filter-confirm-modal .custom-close').on('click', function () {
            $('.filter-confirm-modal').hide();
        });

        $('.filter-confirm-modal .custom-dailog').on('click', function (e) {
            e.stopPropagation();
        });

        $('.custom-discard-close').on('click', function () {
            window.isfilterApplied = false;
            window.isUserClikedOnShow = true;
            $('.filter-confirm-modal').hide();
            $('.sortnfilter-modal').modal('hide');
            if ($('.applied-filters-left') && $('.applied-filters-left').data('filtercount') > 0) {
                $('body').trigger('successToast', $('.results-count-modal').data('message'));
            }
        });

        $('.custom-discard').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            handleFilters($(this), e);
        });
    }
};
